import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import SpinningLogo from '../../components/Spinner';
import CustomPageHeader from '../../components/CustomPageHeader';
import { downloadExcel } from '../../utils/DownloadXls';
import BtnSpinner from '../../components/BtnSpinner';
import { Edit, Trash } from 'lucide-react';
import moment from 'moment';
import Pagination from '../../components/Pagination';
import CustomOffCanvas from '../../components/CustomOffCanvas';
import AddOrEditChapter from './AddOrEditChapter';
import { Apirequests } from '../../utils/ApiRequests';
import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';

function Chapters() {

    const { course_id } = useParams();

    const [isOffCanvasOpen, setIsOffCanvasOpen] = useState({ state: false, name: "" });
    const [chapters, setChapters] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState({ state: false, name: "" });
    const [currentPage, setCurrentPage] = useState(1);
    const [refresh, setRefresh] = useState(false);
    const [currentChapter, setCurrentChapter] = useState(null);
    const [deleteId, setdeleteId] = useState(null)

    const token = localStorage.getItem("token");

    const totalItems = chapters?.length; // Total number of items
    const itemsPerPage = 10;

    const currentData = chapters?.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // console.log(currentData[0],'currr')

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const navigate = useNavigate();

    const handleRefresh = () => setRefresh(!refresh);

    const getChapters = async () => {
        setLoading({ state: true, name: "fetchchapters" });
        try {
            const res = await Apirequests(
                "chapter/get-chapters",
                "GET",
                {},
                {
                    Authorization: `Bearer ${token}`,
                    course_id: course_id
                }
            );
            // console.log(res, 'fetch chapters res')
            if (res?.success) {
                setChapters(res.data);
            }
        } catch (error) {
            console.log(error, "fetch chapter error.");
        }
        setLoading({ state: false, name: "" });
    };

    const handleDeleteChapter= async(id)=>{
        setdeleteId(id);
        setLoading({state:true,name:"deletechapter"})
        try {
            const deleteRes= await Apirequests(`chapter/delete-chapter/${id}`,'DELETE',{},{
                Authorization:`Bearer ${token}`,
                course_id: course_id
            });
            if(deleteRes.success){
                SuccessTost(deleteRes?.message);
                setRefresh(!refresh)
            }else{
                ErrorTost(deleteRes?.message)
            }
        } catch (error) {
            console.log(error,'error deleting chapter');
            ErrorTost("Something went wrong, please try again later.")
        }

        setLoading({state:true,name:""});
        setdeleteId(null)
    }


    useEffect(() => {
        getChapters();
    }, [refresh, token]);

    if (loading.state && loading.name === "fetchchapters") {
        return <div className='h-screen w-full flex items-center justify-center bg-[rgba(255,255,255,0.5)]'>
            <SpinningLogo />
        </div>
    }


    return (
        <div>

            <CustomPageHeader
                title={`Chapters of ${course_id}`}
                text={searchTerm}
                setText={setSearchTerm}
                handleSearch={() => console.log(searchTerm)}
                onClick={() => setIsOffCanvasOpen({ state: true, name: "addchapter" })}
                btnText={"Add Chapter"}
                handleBackClick={() => navigate("/courses")}
                handleRefresh={handleRefresh}
                handleDownload={() => downloadExcel(chapters, 'chapters')}
            />

            <main className="mx-auto py-6 sm:px-6 lg:px-8">
                <div className="px-4 py-6 sm:px-0">
                    <div className="overflow-x-auto">
                        <table className="min-w-full bg-white">
                            <thead className="bg-gray-50 text-center">
                                <tr>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Chapter Id</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Internal Chapter Id</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Chapter Title</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Image</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Lessons</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Description</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Created At</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200 text-center">
                                {currentData?.map((chapter) => (
                                    <tr key={chapter._id}>
                                        <td className="px-6 py-4 whitespace-nowrap">{chapter?.chapterId}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{chapter?._id}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{chapter?.title}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <img src={chapter?.chapterImage} className='w-auto h-[70px] rounded-lg' alt='chapterimg' />
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap"><Link to={`/${course_id}/${chapter?.chapterId}/lessons`}><span className='text-indigo-600 cursor-pointer'>{chapter?.lessons?.length}</span></Link></td>
                                        <td className="px-6 py-4 max-w-[200px]"><span className='elapsis_custom'>{chapter?.description} </span></td>
                                        <td className="px-6 py-4 whitespace-nowrap">{moment(chapter?.createdAt).format("DD-MM-YY")}</td>
                                        <td className="px-6 py-4 flex gap-5 justify-center">
                                            <button className='flex bg-indigo-400 rounded-lg px-3 py-2 items-center gap-1' onClick={() => { setIsOffCanvasOpen({ state: true, name: "editchapter" }); setCurrentChapter(chapter) }}>
                                                <Edit className='text-white' size={20} />
                                                <span className='text-white text-sm'>Edit</span>
                                            </button>
                                            <button className='flex bg-red-200 rounded-lg px-3 py-2 items-center gap-1' onClick={()=> handleDeleteChapter(chapter?.chapterId)}>
                                                {
                                                    loading.state && loading.name === "deletechapter" && deleteId === chapter?.chapterId ?
                                                        <BtnSpinner /> :
                                                        <>
                                                            <Trash className='text-red-700 text-sm' size={20} />
                                                            <span className='text-red-700 text-sm'>Delete</span>
                                                        </>
                                                }

                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                {chapters?.length ?
                    <div className="flex gap-x-2 items-center justify-between">
                        <p>total: {chapters?.length}</p>
                        <Pagination
                            page={currentPage}
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            onPageChange={handlePageChange}
                        />
                    </div> : null}
            </main>

            <CustomOffCanvas
                open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "addchapter"}
                close={() => setIsOffCanvasOpen({ state: false, name: "" })}
                content={
                    <AddOrEditChapter
                        close={() => setIsOffCanvasOpen({ state: false, name: "" })}
                        setRefresh={setRefresh}
                        chapter={currentChapter}
                    />
                }
            />

            <CustomOffCanvas
                open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "editchapter"}
                close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentChapter(null) }}
                content={
                    <AddOrEditChapter
                        close={() => setIsOffCanvasOpen({ state: false, name: "" })}
                        setRefresh={setRefresh}
                        chapter={currentChapter}
                    />
                }
            />

        </div>
    )
}

export default Chapters